module.exports = __webpack_public_path__ + "img/pyth.1dde1cce.svg";